<template>
  <div class="login">
    <div style="width: 100%;justify-content: center;
    height: 40rem;flex-direction: column; display: flex;align-items: center;background: #fff;">
      <img :src='require("@/assets/images/mobile_login.svg")' style="width: 15rem;height: 15rem;">
      <span style="font-size: 3.4rem;font-weight: 700;color:#409EFF;">{{ hospitalname }}</span>
    </div>
    <van-tabs style="margin-top: 1rem;" @click="onClick" color="#409EFF">
      <van-tab title="手机号码登录" v-if="!phoneLoginShow"></van-tab>
      <van-tab title="密码登录"></van-tab>
    </van-tabs>
    <div class="content" v-if="active == 0">
      <div style="width: 100%;">
        <van-form>
          <van-field
              v-model="phone"
              center
              type="tel"
              name="手机号码"
              label="手机号码"
              placeholder="手机号码"
          />
          <van-field
              v-if="imgcodeEnable"
              maxlength="4"
              v-model="imgcode"
              center
              name="图形验证码"
              label="图形验证码"
              placeholder="右侧验证码">
            <template #button>
               <span @click="refreshCode" style="cursor: pointer;">
                  <s-identify :identifyCode="identifyCode"></s-identify>
               </span>
            </template>
          </van-field>
          <van-field
              v-model="code"
              center
              type="digit"
              name="短信验证码"
              label="短信验证码"
              placeholder="短信验证码"
              @input="formatterCode"
          >
            <template #button v-if="active == 0">
              <!--              <van-button size="small" @click="getIdentifyCode" :disabled="sendDisabled"
                                        style="background: #F7937B;color: #fff;width: 90px;height: 35px;">{{ sendText }}
                            </van-button>-->

              <van-button size="small" @click="getIdentifyCode" :disabled="sendDisabled"
                          color="linear-gradient(to right, #10E3E9, #409EFF)"
                          style="color: #fff;width: 90px;height: 35px;">{{ sendText }}
              </van-button>
            </template>
          </van-field>
          <van-field
              v-if="showThreeElements"
              v-model="cardID"
              type="cardID"
              center
              name="身份证"
              label="身份证"
              placeholder="身份证">
          </van-field>
          <van-field
              v-if="showThreeElements"
              v-model="userName"
              type="userName"
              center
              name="姓名"
              label="姓名"
              placeholder="姓名">
          </van-field>
          <div style="margin:5rem 5px;">
            <!--            <van-button @click="loginByCode" block round native-type="submit"
                                    style="background: #F25B30;color: #fff;font-size: 18px;">登 录
                        </van-button>-->

            <van-button @click="() =>{this.showThreeElements?loginByNameCardIDPhone():loginByCode()}" block round
                        native-type="submit"
                        color="linear-gradient(to right, #10E3E9, #409EFF)"
                        style="color: #fff;font-size: 18px;">登 录
            </van-button>


          </div>
        </van-form>
      </div>
    </div>
    <div class="content" v-if="active == 1">
      <div style="width: 100%;">
        <van-form>
          <van-field
              v-model="phone"
              center
              type="tel"
              name="手机号码"
              label="手机号码"
              placeholder="手机号码"
          />
          <van-field
              v-if="imgcodeEnable"
              maxlength="4"
              v-model="imgcode"
              center
              name="图形验证码"
              label="图形验证码"
              placeholder="右侧验证码">
            <template #button>
               <span @click="refreshCode" style="cursor: pointer;">
                  <s-identify :identifyCode="identifyCode"></s-identify>
               </span>
            </template>
          </van-field>
          <van-field
              v-model="password"
              type="password"
              center
              name="密码"
              label="密码"
              placeholder="密码">
          </van-field>
          <van-field
              v-if="showThreeElements"
              v-model="cardID"
              type="cardID"
              center
              name="身份证"
              label="身份证"
              placeholder="身份证">
          </van-field>
          <van-field
              v-if="showThreeElements"
              v-model="userName"
              type="userName"
              center
              name="姓名"
              label="姓名"
              placeholder="姓名">
          </van-field>
          <div style="white-space: pre-wrap;padding: 10px 18px 0 18px;width: 58rem;color: #ff0000;font-size: 16px;"
               v-if="phoneLoginTips">
            {{ phoneLoginTips }}
          </div>
          <div style="margin:5rem 5px 2rem;">
            <!--            <van-button @click="loginByPassword" block round native-type="submit"
                                    style="background: #F25B30;color: #fff;font-size: 18px;">登 录
                        </van-button>-->

            <van-button @click="()=>{this.showThreeElements ? loginByPasswordNameCardID(): loginByPassword()}" block
                        round native-type="submit"
                        color="linear-gradient(to right, #10E3E9, #409EFF)"
                        style="color: #fff;font-size: 18px;">登 录
            </van-button>

          </div>
        </van-form>
      </div>
    </div>
    <div v-if="registOpen" style="text-align: center;bottom: 10rem;left: 0;right: 0">
      <van-button v-if="showLoginReturn" plain round hairline type="success" style="margin: 1rem .5em 0;height: 2em"
                  color="#969799" to="/" @click="clearCachePath">返回首页
      </van-button>
      <van-button plain round hairline type="success" style="margin: 1rem .5em 0;height: 2em" to="/register">账号注册
      </van-button>
      <van-button plain round hairline type="success" style="margin: 1rem .5em 0;height: 2em" @click="forgetPass"
                  v-if="!forgetPassword">忘记密码?</van-button>
    </div>
    <div class="footer" v-if="false">
      <span style="font-size: 14px;color: #9A9A9A;">技术支持：深圳市诺康云科技有限公司</span>
    </div>
    <div class="copyright" v-if="copyrightShow">
      <a href="https://beian.miit.gov.cn" class="link">{{ copyrightText }}</a>
    </div>
    <versions/>
    <van-action-sheet v-model="actionsUserShow" description="手机号关联多个，轻触选择登录">
      <div class="action-sheet-content">
        <div class="action-sheet-content-item" v-for="(item,index) in actionsUser" :key="`userList` + index"
             @click="actionsUserOnSelect(item,index)">
          <div class="head">
            <van-icon :name='require("@/assets/images/head.svg")'/>
          </div>
          <div class="des">
            <p><span class="name">{{ item.name }}</span>({{ item.nickname }}) {{ item.physicalno }}
              <span>
                <van-icon v-if="item.sexid == '1'" :name='require("@/assets/images/sex1.svg")'/>
                <van-icon v-if="item.sexid == '2'" :name='require("@/assets/images/sex2.svg")'/>
              </span>
            </p>
            <p>{{ item.subname }}
              <van-tag plain v-if="item.reportNum > 0" type="success">有 {{ item.reportNum }} 份报告</van-tag>
            </p>
          </div>
          <div class="ops">
            <van-icon name="arrow"/>
          </div>
        </div>
      </div>
    </van-action-sheet>
    <van-action-sheet v-model="actionsUserShowForgetPass" description="手机号关联多个，轻触选择">
      <div class="action-sheet-content">
        <div class="action-sheet-content-item" v-for="(item,index) in actionsUserForgetPass"
             :key="`forgetUserList` + index" @click="actionsUserOnSelectForgetPass(item,index)">
          <div class="head">
            <van-icon :name='require("@/assets/images/head.svg")'/>
          </div>
          <div class="des">
            <p><span class="name">{{ item.name }}</span>({{ item.nickname }})
              <span>
                <van-icon v-if="item.sexid == '1'" :name='require("@/assets/images/sex1.svg")'/>
                <van-icon v-if="item.sexid == '2'" :name='require("@/assets/images/sex2.svg")'/>
              </span>
            </p>
            <p>{{ item.subname }}</p>
          </div>
          <div class="ops">
            <van-icon name="arrow"/>
          </div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import SIdentify from '@/components/identify'
import {Toast, Dialog} from 'vant';
import {
  getCode,
  loginByPhoneCode,
  loginByPassword,
  getUserInfoByPhone,
  loginByNameCardIDPhone,
  getUserInfoByPhoneNameCardID, loginByPasswordNameCardID
} from '@/api/module/user'
import {encrypt, decrypt} from '../../assets/utils/cryptoUtil.js'
import {HideCardIdStr, isValidIDCard} from '@/assets/utils/utils'
import {bindingPhysicalNo} from "@/api/module";
import Versions from "@/components/versions.vue";


export default {
  components: {Versions, SIdentify},
  props: [],
  data() {
    return {
      copyrightShow: window.g.VUE_APP_COPYRIGHT_ISSHOW,
      copyrightText: window.g.VUE_APP_COPYRIGHT_TEXT,
      sendText: '发送验证码',
      sendDisabled: false,
      active: window.g.VUE_APP_PHONE_LOGIN ? 1 : 0,
      phone: '',//登录框默认手机号，线上发布时取消掉
      imgcode: '',
      imgcodeEnable: window.g.VUE_APP_IMGCODE == "1" ? true : false,
      password: '',//登录默认密码
      code: '',
      hospitalname: window.g.VUE_APP_HOSPITALNAME,
      // 图片验证码
      identifyCode: '',
      // 验证码规则
      identifyCodes: '3456789ABCDEFGHGKMNPQRSTUVWXY',
      currentPhone: '',//当前登录手机号码，用于校验
      currentPassword: '',//当前登录密码，用于校验
      currentCode: '',//当前登录验证码，用于校验
      actionsUserShow: false,
      actionsUser: [],//手机号关联帐号动作面板数据
      actionsUserShowForgetPass: false,
      actionsUserForgetPass: [],
      userList: [],//手机号关联帐号数据
      registOpen: window.g.VUE_APP_REGISTER_OPEN,
      passComplex: window.g.VUE_APP_PASS_COMPLEX,
      phoneLogin: window.g.VUE_APP_PHONE_LOGIN,
      // 控制 验证码登陆
      phoneLoginShow: window.g.VUE_APP_PHONE_LOGIN,
      // 控制 密码登录 提示
      phoneLoginTips: window.g.VUE_APP_LOGIN_PASSWORD_TIPS,
      // 控制 忘记密码按钮的显示
      forgetPassword: window.g.VUE_APP_FORGET_PASSWORD,
      // 取本地缓存中的公众号消息推送账号
      PushPatientID: '',
      // 是否显示返回首页按钮
      showLoginReturn: window.g.VUE_APP_LOGIN_RETURN,
      //  是否显示三要素登录： 身份证手机号姓名
      showThreeElements: window.g.VUE_APP_LOGIN_THREE_ELEMENTS,
      // 身份证号码
      cardID: '',
      // 用户名
      userName: ''
    };
  },
  mounted() {
    let loginuser = JSON.parse(localStorage.getItem("loginuser"));
    if (loginuser != null && loginuser.name != '') {
      this.$router.push({name: 'home'})
    }
    //随机生成4位英文字符
    this.identifyCode = this.getRamdonString()
  },
  created() {
    // 清空会话缓存
    sessionStorage.removeItem("userinfo")
    // 清空本地存储
    localStorage.removeItem("token")
    localStorage.removeItem("loginuser")
  },
  methods: {
    //获取短信验证码
    getIdentifyCode() {
      let param = {
        phone: encrypt(this.phone),
        name: this.hospitalname
      }
      if (this.phone == '') {
        Toast.fail('请填写手机号码！');
        return
      }
      if (this.imgcode == '' && this.imgcodeEnable == '1') {
        Toast.fail('请填写图形验证码！');
        return
      }
      if (this.imgcode.toUpperCase() != this.identifyCode.toUpperCase() && this.imgcodeEnable == '1') {
        Toast.fail('图形验证码错误！');
        this.imgcode = ''
        this.refreshCode();
        return
      }
      if (!this.phonevalidate()) {
        return
      }
      getCode(param).then(res => {
        if (res.code == 200) {
          Toast.success(res.msg, {duration: 2000});
          if (res.data == 1) {
            this.sendDisabled = true
            //发送之后，60秒后才能重新发送
            const start = (e) => {
              let timer = null
              timer = setInterval(() => {
                this.sendText = '重发(' + e + ')'
                e--
                if (e < 0) {
                  clearInterval(timer)
                  this.sendDisabled = false
                  this.sendText = '发送验证码'
                }
              }, 1000)
            }
            start(60)
          }
        }
      })
    },
    //修复ios 短信验证码自动填充时总是被复制两遍
    formatterCode(val) {
      if (val.length > 6) {
        this.code = val.substr(0, 6)
      }
    },
    //密码登录
    loginByPassword() {
      if (this.phone == '') {
        Toast.fail('请填写手机号码！');
        return
      }
      if (!this.phonevalidate()) {
        return
      }
      if (this.password == '') {
        Toast.fail('请填写密码！');
        return
      }
      if (this.imgcode == '' && this.imgcodeEnable == '1') {
        Toast.fail('请填写图形验证码！');
        return
      }
      if (this.imgcode.toUpperCase() != this.identifyCode.toUpperCase()) {
        if (this.imgcodeEnable == '1') {
          Toast.fail('图形验证码错误！');
          this.imgcode = ''
          this.refreshCode()
          return;
        }
      }
      let param = {
        phone: encrypt(this.phone),
        password: encrypt(this.password),
        imgCode: this.identifyCode
      }

      if (window.g.VUE_APP_ISWECHAT == 1) {
        let sessionStorage_userinfo = sessionStorage.getItem("userinfo")
        if (sessionStorage_userinfo != null) {
          let session_userinfo = JSON.parse(sessionStorage_userinfo)
          param.wechatid = session_userinfo.openid
          param.nickname = session_userinfo.nickname
        }
      }
      //登录前先存手机号码、密码，未加密之前的
      this.currentPhone = this.phone
      this.currentPassword = this.password
      loginByPassword(param).then(res => {
        if (res.code == 200) {
          if (res.data == null) {
            //剩余次数
            Toast.fail(res.msg);
          } else {
            //密码复杂性验证
            if (this.passComplex) {
              //包含数字、字母大小写、特殊符号（!@#$%^&*），总长度6-12
              let reg = new RegExp("^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\.])[0-9a-zA-Z!@#$%^&*,\\.]{6,12}$", "g")
              if (!reg.test(this.password)) {
                Dialog({
                  message: "密码不符合复杂性要求,为保证账户安全，请立即修改密码后重新登录",
                  theme: 'round-button',
                  confirmButtonText: '修改'
                }).then(() => {
                  this.forgetPass()
                });
                return;
              }
            }

            localStorage.setItem("token", res.data.token)
            //解密 手机号码、密码、身份证号码
            let loginuser = JSON.parse(JSON.stringify(res.data))
            let phone = decrypt(res.data.phone)
            let password = decrypt(res.data.password)
            if (this.currentPhone == '' || this.currentPhone != phone || this.currentPassword == '' || this.currentPassword != password) {
              Toast.fail('非法登录！');
            } else {
              this.getUserInfoByPhone(loginuser);
            }
          }
        }
      })
      this.refreshCode()

    },
    //短信验证码登录
    loginByCode() {
      if (this.phone == '') {
        Toast.fail('请填写手机号码');
        return
      }
      if (!this.phonevalidate()) {
        return
      }
      if (this.imgcode == '' && this.imgcodeEnable == '1') {
        Toast.fail('请填写图形验证码');
        return
      }
      if (this.imgcode.toUpperCase() != this.identifyCode.toUpperCase()) {
        if (this.imgcodeEnable == '1') {
          Toast.fail('图形验证码错误');
          this.refreshCode()
          return
        }
      }

      let param = {
        phone: encrypt(this.phone),
        code: this.code
      }

      this.currentPhone = this.phone
      if (window.g.VUE_APP_ISWECHAT == 1) {
        let sessionStorage_userinfo = sessionStorage.getItem("userinfo")
        if (sessionStorage_userinfo != null) {
          let session_userinfo = JSON.parse(sessionStorage_userinfo)
          param.wechatid = session_userinfo.openid
          param.nickname = session_userinfo.nickname
        }
      }
      loginByPhoneCode(param).then(res => {
        if (res.code == 200) {
          if (res.data == null) {
            Dialog.alert({
              title: '提示',
              message: res.msg,
            }).then(() => {
              // on close
            });
          } else {
            localStorage.setItem("token", res.data.token)
            Toast.success(res.msg);
            //解密 手机号码、身份证、密码
            let loginuser = JSON.parse(JSON.stringify(res.data))
            let phone = decrypt(res.data.phone)
            if (this.currentPhone == '' || this.currentPhone != phone) {
              Toast.fail('非法登录！');
            } else {
              this.getUserInfoByPhone(loginuser);
            }
          }
        }
      })
      this.refreshCode()
    },

    onClick(name) {
      if (name == '0' && !this.phoneLoginShow) {
        this.active = 0
      } else if (name == '1') {
        this.active = 1
      }
      this.refreshCode()
    },
    // 切换验证码
    refreshCode() {
      this.identifyCode = this.getRamdonString()
      this.makeCode(this.identifyCodes, 4)
    },
    // 生成随机验证码
    makeCode(o, l) {
      // eslint-disable-next-line for-direction
      for (let i = 0; i > l; i++) {
        this.identifyCode += this.identifyCodes[
            Math.floor(Math.random() * (this.identifyCodes.length - 0) + 0)
            ]
      }
    },
    //获取随机字符串
    getRamdonString(len) {
      len = len || 4;
      /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
      var $chars = this.identifyCodes;
      var maxLen = $chars.length;
      var str = '';
      for (var i = 0; i < len; i++) {
        str += $chars.charAt(Math.floor(Math.random() * maxLen));
      }
      return str;
    },
    //手机号码验证
    phonevalidate() {
      let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (!myreg.test(this.phone)) {
        Toast.fail('请填写正确的手机号码');
        return false;
      } else {
        return true;
      }
    },
    //手机号关联多个客户选择
    getUserInfoByPhone(loginuser) {
      let param = {
        phone: loginuser.phone
      }
      this.actionsUser = []
      getUserInfoByPhone(param).then(res => {
        if (res.code == 200) {
          if (res.data.length > 1) {
            this.$nextTick(() => {
              //关联记录不止一条
              // Toast.fail("手机号绑定了多条");
              for (let i = 0; i < res.data.length; i++) {
                let obj = {};
                obj.id = res.data[i].id;
                obj.name = decrypt(res.data[i].name);
                obj.nickname = res.data[i].nickname;
                obj.date = res.data[i].date
                obj.reportNum = res.data[i].reportNum
                if (obj.nickname == "") {
                  obj.nickname = '昵称未设置'
                }
                obj.sexid = res.data[i].sexid
                let sexname = ""
                if (res.data[i].sexid == "1") {
                  sexname = "男"
                }
                if (res.data[i].sexid == "2") {
                  sexname = "女"
                }
                obj.sexname = sexname;
                if (res.data[i].cardid != null) {
                  obj.subname = HideCardIdStr(decrypt(res.data[i].cardid));
                }
                if (res.data[i].physicalno != null) {
                  obj.physicalno = decrypt(res.data[i].physicalno);
                }
                this.actionsUser.push(obj);
              }

              this.userList = res.data
              // 20240913 ZLS 判断是否开启公众号推送通知，未开启直接弹出账号选择框
              if (!this.openInformToPatient(res.data)) {
                this.actionsUserShow = true
              }
            })
          } else {
            console.log("loginuser:", loginuser)
            localStorage.setItem("loginuser", JSON.stringify(loginuser))
            localStorage.setItem("token", loginuser.token)
            //20240913 ZLS 判断是否开启公众号推送通知，未开启直接跳转首页
            if (!this.openInformToPatient(null)) {
              this.$router.push({name: 'home'})
            }
          }
        } else {
          Toast.success(res.msg);
          window.localStorage.removeItem("loginuser")
          localStorage.removeItem("token")
        }
      })
    },
    //选择帐号登录
    actionsUserOnSelect: function (action, index) {
      let loginuser = this.userList.filter(item => {
        return item.id == action.id
      })
      localStorage.setItem("loginuser", JSON.stringify(loginuser[0]))
      localStorage.setItem("token", loginuser[0].token)
      if (window.g.VUE_APP_ISWECHAT == 1) {
        // 绑定档案号
        this.bindingPhysicalNo();
      }
      // 获取缓存的跳转信息 进行跳转
      let topath = localStorage.getItem("topath");
      let toquery = localStorage.getItem("toquery");

      if (topath != null && topath != '' && toquery != null && toquery != '{}') {
        // 去掉开头的/
        topath = topath.replace('/', '')

        localStorage.removeItem("topath")
        localStorage.removeItem("toquery");

        console.log("即将跳转到：", topath)
        console.log("即将跳转携带参数：", toquery)
        this.$router.push({name: topath, query: JSON.parse(toquery)})
      } else {
        this.$router.push({name: 'home'})
      }
    },
    //忘记密码 手机号关联多个客户查询
    forgetPass() {
      let _this = this
      if (_this.phone == "") {
        Toast.fail('请填写手机号码！')
        return
      }
      let param = {
        phone: encrypt(_this.phone)
      }

      //跳转修改密码页面
      _this.$router.push({
        name: 'forgetPass', query: {
          phone: encrypt(_this.phone)
        }
      })

      return

      getUserInfoByPhone(param).then(res => {
        if (res.code == 200) {
          if (res.data.length > 1) {
            this.$nextTick(() => {
              //关联记录不止一条
              this.actionsUserForgetPass = []
              for (let i = 0; i < res.data.length; i++) {
                let obj = {};
                obj.id = res.data[i].id;
                obj.name = decrypt(res.data[i].name);
                obj.nickname = res.data[i].nickname;
                if (obj.nickname == "") {
                  obj.nickname = '昵称未设置'
                }
                obj.sexid = res.data[i].sexid

                let sexname = ""
                if (res.data[i].sexid == "1") {
                  sexname = "男"
                }
                if (res.data[i].sexid == "2") {
                  sexname = "女"
                }
                obj.sexname = sexname;
                if (res.data[i].cardid != null) {
                  obj.subname = HideCardIdStr(decrypt(res.data[i].cardid));
                }
                this.actionsUserForgetPass.push(obj);
              }
              console.log(this.actionsUserForgetPass)
              this.actionsUserShowForgetPass = true
              this.userList = res.data
            })
          } else if (res.data.length == 1) {
            //跳转修改密码页面
            _this.$router.push({
              name: 'forgetPass', query: {
                phone: encrypt(_this.phone),
                id: encrypt(res.data[0].id)
              }
            })
          } else {
            Dialog({
              message: "当前手机号未注册，请先注册后再试",
              theme: 'round-button',
            })
          }
        }
      })
    },
    //选择帐号修改密码
    actionsUserOnSelectForgetPass(action, index) {
      let _this = this
      let actionUser = this.userList.filter(item => {
        return item.id == action.id
      })
      //跳转修改密码页面
      this.$router.push({
        name: 'forgetPass', query: {
          phone: encrypt(_this.phone),
          id: encrypt(actionUser[0].id)
        }
      })
    },
    // 20240913 ZLS 判断是否开启微信登陆并且是否缓存了推送账号，未开启未缓存直接返回false
    openInformToPatient(item) {
      //20240913 ZLS 开启微信登陆，并取到了微信公众号推送的账号 则直接调用 账号匹配跳转导检方法
      this.PushPatientID = localStorage.getItem("PushPatientID");
      console.log("PushPatientID", this.PushPatientID);
      console.log("VUE_APP_ISWECHAT", window.g.VUE_APP_ISWECHAT == 1);
      if (this.PushPatientID && window.g.VUE_APP_ISWECHAT == 1) {
        localStorage.removeItem("PushPatientID")
        this.openInformToQueuing(item)
        return true
      }
      return false
    },
    // 20240913 ZLS 获取缓存推送账号，绑定Openid跳转排队通知页面
    openInformToQueuing(item) {
      //获取推送的账号
      var PatientID = this.PushPatientID
      if (Array.isArray(item)) {
        let loginuser = this.userList.filter(item => {
          return item.patientid == PatientID
        })
        localStorage.setItem("loginuser", JSON.stringify(loginuser[0]))
        localStorage.setItem("token", loginuser[0].token)
      }
      if (localStorage.getItem("loginuser") && localStorage.getItem("token")) {
        let loginuser = JSON.parse(localStorage.getItem("loginuser"))
        let openID = undefined
        let sessionStorage_userinfo = sessionStorage.getItem("userinfo")
        if (sessionStorage_userinfo != null) {
          let session_userinfo = JSON.parse(sessionStorage_userinfo)
          openID = session_userinfo.openid
        }
        if (openID && loginuser.phone && loginuser.physicalno) { // 有openID
          let param = {
            phone: loginuser.phone,
            physicalno: loginuser.physicalno,
            openId: openID
          }
          bindingPhysicalNo(param).then(res => { // 保存OpenId后跳转到导检
            console.log("即将跳转至体检排队")
            console.log(res.msg)
            this.$router.push({name: 'queuing'})
          })
        } else {
          console.log("openID,phone,physicalno或为空")
          // 如果未绑定成功，则弹出账号列表选择框
          this.actionsUserShow = true
        }
      } else {
        // 如果传递的账号没不在登录账号列表中，则弹出账号列表选择框
        this.actionsUserShow = true
      }
    },
    // 绑定openId
    bindingPhysicalNo() {
      console.log("开启微信登陆绑定openId")
      let sessionStorage_userinfo = sessionStorage.getItem("userinfo")
      let loginuser = JSON.parse(localStorage.getItem("loginuser"))
      if (sessionStorage_userinfo == null || loginuser == null) {
        return null;
      }
      let session_userinfo = JSON.parse(sessionStorage_userinfo)
      let openID = session_userinfo.openid
      let param = {
        phone: loginuser.phone,
        physicalno: loginuser.physicalno,
        openId: openID
      }
      bindingPhysicalNo(param).then(res => {
        console.log(res.msg)
      }).catch(err => {
      })
    },
    // 跳转回首页前清除缓存路径
    clearCachePath() {
      localStorage.removeItem(
          "topath"
      )
    },

    //密码、身份证、姓名登录
    loginByPasswordNameCardID() {
      if (this.phone == '') {
        Toast.fail('请填写手机号码！');
        return
      }
      if (!this.phonevalidate()) {
        return
      }
      if (this.password == '') {
        Toast.fail('请填写密码！');
        return
      }
      if (this.imgcode == '' && this.imgcodeEnable == '1') {
        Toast.fail('请填写图形验证码！');
        return
      }
      if (this.imgcode.toUpperCase() != this.identifyCode.toUpperCase()) {
        if (this.imgcodeEnable == '1') {
          Toast.fail('图形验证码错误！');
          this.imgcode = ''
          this.refreshCode()
          return;
        }
      }
      if (this.cardID == '' && this.showThreeElements) {
        Toast.fail('请填写身份证号码');
        return
      }
      if (!isValidIDCard(this.cardID) && this.showThreeElements) {
        Toast.fail('请填写正确的身份证号码');
        return
      }
      if (this.userName == '' && this.showThreeElements) {
        Toast.fail('请填写姓名');
        return
      }
      let param = {
        phone: encrypt(this.phone),
        password: encrypt(this.password),
        imgCode: this.identifyCode,
        cardid: encrypt(this.cardID),
        name: encrypt(this.userName)
      }

      if (window.g.VUE_APP_ISWECHAT == 1) {
        let sessionStorage_userinfo = sessionStorage.getItem("userinfo")
        if (sessionStorage_userinfo != null) {
          let session_userinfo = JSON.parse(sessionStorage_userinfo)
          param.wechatid = session_userinfo.openid
          param.nickname = session_userinfo.nickname
        }
      }
      //登录前先存手机号码、密码，未加密之前的
      this.currentPhone = this.phone
      this.currentPassword = this.password
      loginByPasswordNameCardID(param).then(res => {
        if (res.code == 200) {
          if (res.data == null) {
            //剩余次数
            Toast.fail(res.msg);
          } else {
            //密码复杂性验证
            if (this.passComplex) {
              //包含数字、字母大小写、特殊符号（!@#$%^&*），总长度6-12
              let reg = new RegExp("^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\.])[0-9a-zA-Z!@#$%^&*,\\.]{6,12}$", "g")
              if (!reg.test(this.password)) {
                Dialog({
                  message: "密码不符合复杂性要求,为保证账户安全，请立即修改密码后重新登录",
                  theme: 'round-button',
                  confirmButtonText: '修改'
                }).then(() => {
                  this.forgetPass()
                });
                return;
              }
            }
            Toast.success(res.msg);
            localStorage.setItem("token", res.data.token)
            //解密 手机号码、密码、身份证号码
            let loginuser = JSON.parse(JSON.stringify(res.data))
            let phone = decrypt(res.data.phone)
            let password = decrypt(res.data.password)
            if (this.currentPhone == '' || this.currentPhone != phone || this.currentPassword == '' || this.currentPassword != password) {
              Toast.fail('非法登录！');
            } else {
              this.getUserInfoByPhoneNameCardID(loginuser);
            }
          }
        }
      })
      this.refreshCode()

    },

//手机号码、验证码、 身份证、姓名登录
    loginByNameCardIDPhone() {
      if (this.phone == '') {
        Toast.fail('请填写手机号码');
        return
      }
      if (!this.phonevalidate()) {
        return
      }
      if (this.imgcode == '' && this.imgcodeEnable == '1') {
        Toast.fail('请填写图形验证码');
        return
      }
      if (this.imgcode.toUpperCase() != this.identifyCode.toUpperCase()) {
        if (this.imgcodeEnable == '1') {
          Toast.fail('图形验证码错误');
          this.refreshCode()
          return
        }
      }
      if (this.cardID == '' && this.showThreeElements) {
        Toast.fail('请填写身份证号码');
        return
      }
      if (!isValidIDCard(this.cardID) && this.showThreeElements) {
        Toast.fail('请填写正确的身份证号码');
        return
      }
      if (this.userName == '' && this.showThreeElements) {
        Toast.fail('请填写姓名');
        return
      }
      let param = {
        phone: encrypt(this.phone),
        code: this.code,
        cardID: encrypt(this.cardID),
        userName: encrypt(this.userName)
      }

      this.currentPhone = this.phone
      if (window.g.VUE_APP_ISWECHAT == 1) {
        let sessionStorage_userinfo = sessionStorage.getItem("userinfo")
        if (sessionStorage_userinfo != null) {
          let session_userinfo = JSON.parse(sessionStorage_userinfo)
          param.wechatid = session_userinfo.openid
          param.nickname = session_userinfo.nickname
        }
      }
      loginByNameCardIDPhone(param).then(res => {
        if (res.code == 200) {
          if (res.data == null) {
            Dialog.alert({
              title: '提示',
              message: res.msg,
            }).then(() => {
              // on close
            });
          } else {
            Toast.success(res.msg);
            //解密 手机号码、身份证、密码
            let loginuser = JSON.parse(JSON.stringify(res.data))
            let phone = decrypt(res.data.phone)
            if (this.currentPhone == '' || this.currentPhone != phone) {
              Toast.fail('非法登录！');
            } else {
              this.getUserInfoByPhoneNameCardID(loginuser);
            }
          }
        }
      })
      this.refreshCode()
    },
    //手机号身份证姓名关联多个客户选择
    getUserInfoByPhoneNameCardID(loginuser) {
      let param = {
        phone: loginuser.phone,
        name: loginuser.name,
        cardID: loginuser.cardid
      }
      this.actionsUser = []
      getUserInfoByPhoneNameCardID(param).then(res => {
        if (res.code == 200) {
          if (res.data.length > 1) {
            this.$nextTick(() => {
              //关联记录不止一条
              // Toast.fail("手机号绑定了多条");
              for (let i = 0; i < res.data.length; i++) {
                let obj = {};
                obj.id = res.data[i].id;
                obj.name = decrypt(res.data[i].name);
                obj.nickname = res.data[i].nickname;
                obj.date = res.data[i].date
                obj.reportNum = res.data[i].reportNum
                if (obj.nickname == "") {
                  obj.nickname = '昵称未设置'
                }
                obj.sexid = res.data[i].sexid
                let sexname = ""
                if (res.data[i].sexid == "1") {
                  sexname = "男"
                }
                if (res.data[i].sexid == "2") {
                  sexname = "女"
                }
                obj.sexname = sexname;
                if (res.data[i].cardid != null) {
                  obj.subname = HideCardIdStr(decrypt(res.data[i].cardid));
                }
                if (res.data[i].physicalno != null) {
                  obj.physicalno = decrypt(res.data[i].physicalno);
                }
                this.actionsUser.push(obj);
              }

              this.userList = res.data
              // 20240913 ZLS 判断是否开启公众号推送通知，未开启直接弹出账号选择框
              if (!this.openInformToPatient(res.data)) {
                this.actionsUserShow = true
              }
            })
          } else {
            console.log("loginuser:", loginuser)
            localStorage.setItem("loginuser", JSON.stringify(loginuser))
            localStorage.setItem("token", loginuser.token)
            //20240913 ZLS 判断是否开启公众号推送通知，未开启直接跳转首页
            if (!this.openInformToPatient(null)) {
              this.$router.push({name: 'home'})
            }
          }
        }
      })
    },

  },
}
;
</script>

<style lang="scss" scoped>
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.content {
  width: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
}

.login-active {
  background: #F7937B;
  color: #fff;
}

.login-items {
  width: 49.5%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  font-weight: 500;
}

.login-top {
  width: 100%;
  height: 100px;
  background: #e1e5df;
  display: flex;
  flex-flow: row;
  justify-content: space-around;
}

.login {
  background: #F0EFF4;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;

  &-b {
    color: red;
  }
}

.copyright {
  text-align: center;
  font-size: 2em;
  color: #999;
  padding: 2em;
}

.copyright .link {
  text-decoration: underline;
  color: #999;
}

/*用户列表*/
.action-sheet-content {
  padding: 2em 4em;
  color: #999;
}

.action-sheet-content .action-sheet-content-item {
  padding: .8em 0;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.action-sheet-content .action-sheet-content-item .head {
  width: 2em;
}

.action-sheet-content .action-sheet-content-item .head img {
  width: 100%;
  height: 100%;
}

.action-sheet-content .action-sheet-content-item .des {
  padding-left: .5em;
  flex: 1;
}

.action-sheet-content .action-sheet-content-item .ops {
  display: flex;
  align-items: center;
}

.action-sheet-content .action-sheet-content-item,
.action-sheet-content .action-sheet-content-item p {
  font-size: 26px;
}

.action-sheet-content .action-sheet-content-item p .name {
  font-size: 30px;
  font-weight: bold;
  color: #000;
}
</style>
